import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd } from '@angular/router';
import { Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { SubSink } from 'subsink';

@Component({
    selector: 'app-onboarding-header',
    templateUrl: './onboarding-header.component.html',
    standalone: false
})
export class OnboardingHeaderComponent implements OnInit, OnDestroy {
  @Input()
  showHeader: boolean;
  private subs = new SubSink();
  addCustomerViewActive = false;

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.subs.sink = this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(event => {
      if (event && event['url']) {
        this.addCustomerViewActive =
          event['url'].includes('/secure/register') && !event['url'].includes('/secure/register/verifyemail');
      }
    });
  }
  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
